// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable react/style-prop-object */ /* eslint-disable max-len */
import React from 'react';
import { useParams } from 'react-router-dom';
import CookiePolicyEN from './en';
import CookiePolicyID from './id';

interface RouteParams {
  lang: string;
}

const CookiePolicy: React.FC = () => {
  const { lang } = useParams<RouteParams>();

  if (lang === 'en') {
    return <CookiePolicyEN />;
  }

  return <CookiePolicyID />;
};

export default CookiePolicy;
